// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sEAI","option":"styles_option__2OC2B","active":"styles_active__2g42H"};